import React, { useEffect, useState, useCallback, useRef } from "react";
import Dropdown from "../../../../components/common/dropdown";
import Button from "../../../../components/common/button";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import Addicon from "../../../../assets/icons/Addicon.svg";
import { colors, promoDealCode } from "./../../../../share/constants/enums";
import {
  Form,
  message,
  Input as InputField,
  Pagination,
  Spin,
  InputNumber,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchService,
  fetchServiceCategory,
} from "../../../../store/slices/serviceSlice";
import { teslaService } from "./../../../../share/constants/enums";
import TextArea from "../../../../components/common/textArea";
import DealCard from "../../../../components/addDeal/dealCard";
import {
  deleteService,
  postService,
  updateService,
} from "../../../../api/service";
import DeleteMemberModal from "../../../../components/common/modalMember";
import {
  deleteDealCard,
  multipleServiceImages,
  serviceImage,
} from "../../../../api/settings";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import SubMenuDropdown from "../../../../components/common/subMenuDropdown";
import { Link } from "react-router-dom";
import { fetchBusiness } from "../../../../store/slices/businessSlice";
import { getBusinessLocations } from "../../../../api/business";

const Settings = ({ isSetupPage }) => {
  // Initializations
  const dispatch = useDispatch();
  const scrollRef = useRef();
  const [form] = Form.useForm();

  // Use States
  const [deleteId, setDeleteId] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [images, setImages] = useState({});
  const [showTesla, setShowTesla] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [renderOnSave, setRenderOnSave] = useState(false);
  const [locations, setLocations] = useState();
  const [loader, setLoader] = useState(false);
  const [editedCard, setEditedCard] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(3);
  const [serviceObj, setServiceObj] = useState(["", ""]);
  const [iloader, setIloader] = useState([]);
  const [variants, setVariants] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [serviceIncludesVariants, setServiceIncludesVariants] = useState([]);
  const [service, setService] = useState([{ id: 0 }, { id: 1 }]);
  const [value, setValues] = useState({
    serviceDescription: "",
    serviceIncluded1: "",
    serviceIncluded2: "",
    finePrint: "",
  });
  // Use Selectors
  const businessMaxQuantity = useSelector(
    (state) => state?.business?.business?.maxQuantity
  );

  const stateData = useSelector((state) => {
    return state.service;
  });
  const serviceCategories = stateData.value.serviceCategory;
  const serviceCards = stateData.value.service;

  // Functions
  const showModal = (id) => {
    setIsModalOpen(true);
    setDeleteId(id);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getServiceCategories = useCallback(async () => {
    dispatch(fetchServiceCategory());
  }, [dispatch]);

  const onFinish = (values) => {
    handleSaveButton(values);
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const YesClickHandler = async () => {
    setIsModalOpen(false);
    setIsEditing(false);

    try {
      const res = await deleteDealCard(deleteId);
      if (res) {
        form.resetFields();
        setRenderOnSave(!renderOnSave);
        message.success("Service Card Deleted!");
        setValues({
          serviceDescription: "",
          serviceIncluded1: "",
          serviceIncluded2: "",
          finePrint: "",
        });
        setEditedCard(null);
        setSelectedFile(null);
        setFiles([]);
        setIsDeleted(!isDeleted);
      }
    } catch (error) {
      message.error("Error in Deleting Deal Card");
    }
  };

  const handleTextOnChange = (val) => {
    setValues({ ...value, serviceDescription: val });
  };

  const handleService = (val, id, isEditing) => {
    if (isEditing) {
      let editServiceIncludes = [...editedCard?.includeService];

      editServiceIncludes[id] = val;
      const editedServiceWithIncludedServices = {
        ...editedCard,
        includeService: [...editServiceIncludes],
      };
      setEditedCard(editedServiceWithIncludedServices);
    } else {
      let includedServices = serviceObj;
      includedServices[id] = val;
      setServiceObj([...includedServices]);
    }
  };

  const handleRemoveService = (id) => {
    setServiceObj((prevService, ind) =>
      prevService.filter((service, index) => index !== id)
    );
  };

  const hadleRemoveservicewhileediting = (id) => {
    const res = editedCard.includeService.filter((item, i) => i !== id);
    setEditedCard({ ...editedCard, includeService: res });
  };

  const handlefineprint = (val) => {
    setValues({ ...value, finePrint: val });
  };

  const updateServiceCards = async (data) => {
    if (
      data?.serviceCategory?._id === "64e87bbeb2b8697561f80fec" ||
      data?.serviceCategory?._id === "66f4163f8af89873ed86f1d4" ||
      data?.multipleCategories?.includes("66f4163f8af89873ed86f1d4") ||
      data?.multipleCategories?.includes("64e87bbeb2b8697561f80fec")
    ) {
      setShowTesla(true);
    }
    setVariants(data?.variants || []);
    setRenderOnSave(!renderOnSave);
    const variantForm = data?.variants?.map((variant, index) => ({
      key: index,
      _id: variant._id,
      variantTitle: variant.variantTitle,
      servicePrice: variant.servicePrice,
      discount: variant.discountAmount,
      serviceDescription: variant.serviceDescription,
      serviceImage: variant.serviceImage,
      includeService: variant.includeService,
    }));
    setVariants(variantForm || []);

    const serviceIncludesVariantsData = data?.variants?.map((variant) =>
      variant?.includeService?.map((service) => ({
        description: service?.description || "",
      }))
    );

    setServiceIncludesVariants(serviceIncludesVariantsData || []);
    form.setFieldsValue({
      discountAmount: data.discountAmount,
      serviceName: data.serviceName,
      category: data?.multipleCategories?.length
        ? data.multipleCategories
        : [data.serviceCategory._id],
      subcategory: data?.multipleSubCategories?.length
        ? data?.multipleSubCategories
        : [data?.subServiceCategoryId?._id],
      price: data.servicePrice,
      quantity: data.maxQuantity,
      isTeslaService: data.isTeslaService,
      variants: variantForm,
      variantTitle: data.variantTitle,
      serviceLocation: data.serviceLocation._id,
      video: data.video,
      promoDealCode: data.promoDealCode,
      serviceDescription: data.serviceDescription,
      includeService: [...data?.includeService],
    });

    setValues({
      ...value,
      serviceDescription: data?.serviceDescription,
      finePrint: data?.finePrint,
    });

    const updatedMultipleImages = [];
    if (data?.serviceImage) {
      if (!data?.multipleImages?.includes(data?.serviceImage)) {
        updatedMultipleImages.push(
          data?.serviceImage,
          ...(data?.multipleImages || [])
        );
      } else {
        updatedMultipleImages.push(...(data?.multipleImages || []));
      }
      setEditedCard({ ...data, multipleImages: updatedMultipleImages });
      const formattedImagesForSetFiles = updatedMultipleImages?.map(
        (item, i) => {
          if (item === data?.serviceImage) {
            setSelectedFile({
              index: i,
              file: item,
            });
          }
          return {
            index: i,
            file: item,
          };
        }
      );
      setFiles(formattedImagesForSetFiles);
    } else {
      setEditedCard(data);
    }

    setIsEditing(true);
  };

  const uploadImages = async () => {
    const formData = new FormData();
    const singleFormData = new FormData();
    const promises = [];
    for (let i = 0; i < files.length; i++) {
      if (i === selectedFile.index) {
        if (files[i]?.file?.size) {
          singleFormData.append("image", selectedFile.file);
        }
      } else {
        if (files[i]?.url) {
          formData.append("images", files[i]?.file);
        }
      }
    }
    try {
      const singleImage = singleFormData.getAll("image");
      const multipleImages = formData.getAll("images");
      if (singleImage?.length) {
        promises.push(serviceImage(singleFormData));
      }
      if (multipleImages?.length) {
        promises.push(multipleServiceImages(formData));
      }
      const uploadResponse = await Promise.all(promises);
      return {
        singleImageRes: singleImage?.length ? uploadResponse[0] : null,
        multipleImagesRes: singleImage?.length
          ? uploadResponse[1]
          : uploadResponse[0],
      }; // Return both responses
    } catch (error) {
      console.error("Error uploading multiple images:", error);
      return null; // Return null if an error occurs
    }
  };

  const handleSaveButton = async (values) => {
    let uploadedImagesResult = null;
    try {
      setLoader(true);
      if (files && files?.length > 0) {
        uploadedImagesResult = await uploadImages();
      }
      const uploadedImageUrl = uploadedImagesResult?.singleImageRes?.url;
      const selectedFileUrl =
        typeof selectedFile?.file === "string"
          ? selectedFile.file
          : editedCard?.serviceImage;
      const updateFiles = files.filter((item) => {
        if (!item.url) {
          if (isEditing) {
            if (item.file !== (uploadedImageUrl || selectedFileUrl)) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      });

      const formattedUploadedFiles =
        uploadedImagesResult?.multipleImagesRes?.map((item, i) => ({
          index: updateFiles.length + i,
          file: item,
        })) || [];

      const updateFilesPayload = [...updateFiles, ...formattedUploadedFiles];
      setFiles(updateFilesPayload);

      if (isEditing) {
        const variantEdited = editedCard?.variants?.map((variant, index) => ({
          _id: variant._id,
          variantTitle: variant.variantTitle,
          servicePrice: variant.servicePrice,
          discount: variant.discountAmount,
          serviceDescription: variant.serviceDescription,
          serviceImage: variant.serviceImage,
        }));
        const updatedVariants = values?.variants?.map((variant, index) => ({
          ...variant,
          _id: editedCard?.variants?.[index]?._id || null,
          serviceImage:
            images[index] ||
            editedCard?.variants?.[index]?.serviceImage ||
            null,
        }));
        const finalVariants = updatedVariants?.map((variant) => {
          const existingVariant = variants.find(
            (v) => v._id === variant._id && Object.keys(v).length === 1
          );

          if (existingVariant) {
            return { _id: variant._id };
          }

          return variant;
        });
        const payload = {
          serviceName: values.serviceName ?? editedCard.serviceName,
          serviceCategoryId:
            values.category[0] ?? editedCard.serviceCategory?._id,
          multipleCategories:
            values?.category ?? editedCard?.multipleCategories,
          subServiceCategoryId:
            values?.subcategory[0] ?? editedCard?.subServiceCategoryId?._id,
          multipleSubCategories:
            values?.subcategory ?? editedCard?.multipleSubCategories,
          servicePrice: values.price ?? editedCard.servicePrice,
          discount: values.discountAmount ?? editedCard.discountAmount,
          isTeslaService: values.isTeslaService ?? editedCard.isTeslaService,
          finePrint: value.finePrint ?? editedCard.finePrint,
          serviceLocation:
            values?.serviceLocation ?? editedCard?.serviceLocation?._id,
          video: values.video ?? editedCard?.video,
          maxQuantity: values.quantity ?? editedCard.maxQuantity,
          variantTitle: values.variantTitle ?? editedCard.variantTitle,
          isKidsFriendly: values.isKidsFriendly ?? editedCard.isKidsFriendly,
          promoDealType: values.promoDealType ?? editedCard.promoDealType,
          variants: finalVariants ?? variantEdited,
          serviceDescription:
            value.serviceDescription ?? editedCard.serviceDescription,
          serviceImage:
            uploadedImagesResult?.singleImageRes?.url ||
            (typeof selectedFile?.file === "string" ? selectedFile.file : null),
          multipleImages: updateFilesPayload?.length
            ? updateFilesPayload.map((item) => item.file)
            : [],
          includeService: isEditing ? editedCard?.includeService : serviceObj,
        };
        const res = await updateService(editedCard?._id, payload);
        if (res) {
          message.success("Service Updated Successfully");
          setRenderOnSave(!renderOnSave);
          setIsEditing(false);
          setEditedCard(null);
          setValues({
            serviceDescription: "",
            serviceIncluded1: "",
            serviceIncluded2: "",
            finePrint: "",
          });
          form?.resetFields();
          setImages({});
        }
      } else {
        if (serviceObj[1] === "") {
          serviceObj.splice(1, 1);
        }
        const updatedVariants = values?.variants?.map((variant, index) => ({
          ...variant,
          serviceImage: images[index] || null,
        }));
        const payload = {
          serviceName: values.serviceName,
          serviceCategoryId: values.category[0],
          multipleCategories: values.category,
          subServiceCategoryId: values.subcategory[0],
          multipleSubCategories: values.subcategory,
          servicePrice: values.price,
          discount: values.discountAmount,
          isTeslaService: showTesla ? values.isTeslaService : false,
          finePrint: value.finePrint,
          isChild: false,
          promoDealType: values.promoDealType,
          maxQuantity: values.quantity,
          serviceLocation: values.serviceLocation,
          variantTitle: values.variantTitle,
          isKidsFriendly: values.isKidsFriendly ?? false,
          variants: updatedVariants,
          serviceDescription: value.serviceDescription,
          includeService: serviceObj,
        };
        if (uploadedImagesResult?.singleImageRes) {
          payload.serviceImage = uploadedImagesResult?.singleImageRes?.url;
        }
        if (values.video) {
          payload.video = values?.video;
        }
        if (
          uploadedImagesResult?.multipleImagesRes &&
          uploadedImagesResult?.multipleImagesRes?.length > 0
        ) {
          payload.multipleImages = uploadedImagesResult?.multipleImagesRes;
        }
        const res = await postService(payload);
        if (res) {
          message.success("Service Added Successfully");
          setRenderOnSave(!renderOnSave);
          setEditedCard(null);
          setValues({
            serviceDescription: "",
            serviceIncluded1: "",
            serviceIncluded2: "",
            finePrint: "",
          });
          form.resetFields();
          setImages({});
        }
      }
    } catch (error) {
      console.error("Error while making API call:", error);
    } finally {
      setLoader(false);
      setFiles([]);
      setSelectedFile(null);
    }
  };

  const handleChangeAndUploadImageVariant = async (e, key) => {
    setIloader((prevIloader) => {
      const newIloader = [...prevIloader];
      newIloader[key] = true;
      return newIloader;
    });
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await serviceImage(formData);

        if (response?.url) {
          setImages((prevImages) => ({
            ...prevImages,
            [key]: response?.url,
          }));
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setIloader((prevIloader) => {
          const newIloader = [...prevIloader];
          newIloader[key] = false;
          return newIloader;
        });
      }
    } else {
      setIloader((prevIloader) => {
        const newIloader = [...prevIloader];
        newIloader[key] = false;
        return newIloader;
      });
    }
  };

  const handleChangeAndUploadMultipleImages = async (e) => {
    const files = Array.from(e.target.files);
    const imageFiles = files.map((file) => ({
      url: URL.createObjectURL(file),
      file,
    }));
    setFiles((prevImages) => {
      const updatedImages = [...prevImages, ...imageFiles];
      setSelectedFile({ index: 0, file: updatedImages[0]?.file });
      return updatedImages;
    });
  };

  const handleMultipleDeleteUploadFileIcon = (index) => {
    setFiles((prevImages) => {
      if (prevImages.length >= 2) {
        return prevImages.filter((_, i) => i !== index);
      } else {
        return prevImages;
      }
    });

    if (index === selectedFile?.index && files?.length > 1) {
      const res = files.filter((data, i) => {
        if (index === 0) {
          if (i === 1) {
            return data;
          }
        } else {
          if (i === 0) {
            return data;
          }
        }
      });
      setSelectedFile({
        index: 0,
        file: res[0]?.file,
      });
    } else if (index < selectedFile?.index) {
      const res = files.filter((_, i) => i === selectedFile.index);
      setSelectedFile((prevImage) => {
        return {
          index: prevImage.index - 1,
          file: res[0]?.file,
        };
      });
    }
  };

  const handleDeleteUploadFileIconVariant = (key) => {
    if (isEditing) {
      setEditedCard((prevEditedCard) => {
        if (!prevEditedCard?.variants) {
          return prevEditedCard;
        }
        const updatedVariants = prevEditedCard.variants.map((variant, index) =>
          index === key ? { ...variant, serviceImage: null } : variant
        );
        return {
          ...prevEditedCard,
          variants: updatedVariants,
        };
      });
    } else {
      setImages((prevImages) => {
        const newImages = { ...prevImages };
        delete newImages[key];
        return newImages;
      });
    }
  };

  const validateDiscount = (rule, value, callback) => {
    const { getFieldValue } = form;
    const servicePrice = getFieldValue("price");
    if (value > servicePrice) {
      callback("Discount amount cannot be greater than service price");
    } else {
      callback();
    }
  };

  const validateQuantity = (rule, value, callback) => {
    // const { getFieldValue } = form;
    // const serviceQuantity = getFieldValue("quantity");
    if (value > businessMaxQuantity) {
      callback(`Max Quantity cannot be greater than ${businessMaxQuantity}`);
    } else {
      callback();
    }
  };

  const handleAddIncludedServices = () => {
    if (isEditing) {
      if (editedCard?.includeService?.length > 0) {
        let editService = { ...editedCard };
        editService.includeService = [...editService?.includeService, ""];
        setEditedCard(editService);
      } else {
        setService([...service, { id: editedCard?.includeService?.length }]);
      }
    } else {
      setServiceObj([...serviceObj, ""]);
    }
  };

  const handleAddVariant = () => {
    if (variants?.length < 2) {
      setVariants([...variants, { key: variants.length }]);
      setServiceIncludesVariants([
        ...serviceIncludesVariants,
        [{ description: "" }, { description: "" }], // Add two default fields for the new variant
      ]);
    }
  };

  const handleRemoveVariant = async (data) => {
    // setVariants(variants.filter((variant) => variant.key !== data.key));
    setVariants((prevVariants) => {
      const updatedVariants = prevVariants?.filter(
        (variant) => variant?.key !== data?.key
      );
      form.setFieldsValue({
        variants: updatedVariants?.map((variant, index) => ({
          ...form.getFieldValue(["variants", index]),
        })),
      });
      return updatedVariants;
    });

    const updatedVariants = variants.find((variant) => {
      return variant._id === data._id;
    });
    if (updatedVariants?._id) {
      await deleteService(updatedVariants?._id);
    }
  };

  const handleSelectingCategory = async (id) => {
    const teslaCategories = [
      "64e87bbeb2b8697561f80fec",
      "64e87bbeb2b8697561f80fec",
    ];

    const selected = serviceCategories?.filter((item) =>
      id.includes(item?._id)
    );

    const isShowTesla = selected?.filter((item) =>
      teslaCategories.includes(item?._id)
    );
    if (isShowTesla?.length) setShowTesla(true);
    else setShowTesla(false);
  };

  const handleAddFieldsVariants = (index) => {
    setServiceIncludesVariants((prevServiceIncludes) => {
      const newServiceIncludes = [...prevServiceIncludes];
      newServiceIncludes[index] = [
        ...newServiceIncludes[index],
        { description: "" },
      ];
      return newServiceIncludes;
    });
  };

  const handleServiceIncludeChangeVariants = (index, fieldIndex, value) => {
    const newServiceIncludes = [...serviceIncludesVariants];
    newServiceIncludes[index][fieldIndex].description = value;
    setServiceIncludesVariants(newServiceIncludes);
    form.setFieldValue(
      ["variants", index, "includeService", fieldIndex],
      value
    );
  };

  const handleRemoveLastFieldVariant = (variantIndex) => {
    setServiceIncludesVariants((prevState) => {
      const updatedVariants = [...prevState];

      // Ensure there are more than two fields before removing the last one
      if (updatedVariants[variantIndex].length > 2) {
        // Remove only the last field without affecting others
        updatedVariants[variantIndex].pop();
      }

      return updatedVariants;
    });
  };

  useEffect(() => {
    const payload = {
      pageNumber: currentPage,
      pageSize: pageSize,
    };
    dispatch(fetchService(payload));
  }, [currentPage, pageSize, renderOnSave, isEditing, isDeleted, dispatch]);

  useEffect(() => {
    getServiceCategories();
    dispatch(fetchBusiness());
  }, []);

  useEffect(() => {
    // Only set initial serviceIncludesVariants if it's empty
    if (
      variants &&
      variants.length > 0 &&
      serviceIncludesVariants.length === 0
    ) {
      setServiceIncludesVariants(
        variants?.map((variant, index) =>
          variant.serviceIncludes && variant.serviceIncludes.length > 0
            ? variant.serviceIncludes
            : [{ description: "" }, { description: "" }]
        )
      );
    }
  }, [variants]);

  const fetchBusinessLocations = async () => {
    const response = await getBusinessLocations();
    if (response) {
      setLocations(response);
    }
  };

  useEffect(() => {
    fetchBusinessLocations();
  }, []);

  const extractedLocations = locations?.map(
    ({ _id, businessAddress, city, state }) => ({
      _id,
      name: `${businessAddress}, ${city}, ${state}`,
    })
  );

  return (
    <>
      {stateData?.isLoading ? (
        <div className="h-screen w-full flex items-center justify-center">
          <Spin indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
          <div className="px-3" ref={scrollRef}>
            {isSetupPage ? (
              <div className="flex flex-col w-full xl:grid xl:grid-cols-2 mt-4 lg:mt-0">
                <div className="xl:col-span-1 xl:col-start-2">
                  <Link to="/payment" className="no-underline ">
                    <Button
                      title="Skip For Now & Add Later"
                      border={colors.primaryPurple}
                      className="text-primaryPurple w-full"
                    />
                  </Link>
                </div>
              </div>
            ) : (
              <div>
                <p className="text-lg font-medium tracking-wider">
                  Add New Services
                </p>
              </div>
            )}

            <div
              className={`p-2 ${
                isSetupPage
                  ? ""
                  : "border-solid border-inputFieldGrey rounded-sm"
              }  justify-center items-center`}
            >
              <div className="flex flex-col space-y-2 items-center mt-3 xl:items-start xl:space-y-0">
                <Form form={form} className="w-full" onFinish={onFinish}>
                  <div className="md:grid md:grid-cols-4 md:gap-2">
                    <Form.Item
                      name="serviceLocation"
                      className="w-full rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <Dropdown
                        placeholder={"Location"}
                        defaultValue={
                          isEditing && editedCard?.serviceLocation
                            ? `${editedCard?.serviceLocation?.businessAddress}, ${editedCard?.serviceLocation?.city}, ${editedCard?.serviceLocation?.state}`
                            : undefined
                        }
                        data={extractedLocations}
                      />
                    </Form.Item>
                    <Form.Item
                      name="category"
                      className="w-full rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <Dropdown
                        mode="multiple"
                        placeholder={"Category"}
                        defaultValue={
                          (editedCard?.multipleCategories?.length &&
                            editedCard.multipleCategories) ||
                          (editedCard?.serviceCategory?._id && [
                            editedCard.serviceCategory._id,
                          ])
                        }
                        onChange={handleSelectingCategory}
                        data={serviceCategories}
                      />
                    </Form.Item>
                    <Form.Item
                      name="subcategory"
                      className="w-full rounded-md "
                      validateTrigger={["onChange", "onBlur"]} // Triggers validation when the value changes
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <SubMenuDropdown
                        mode="multiple"
                        placeholder={"Sub-Category"}
                        defaultValue={
                          (editedCard?.multipleSubCategories?.length &&
                            editedCard?.multipleSubCategories) ||
                          (editedCard?.subServiceCategoryId?._id && [
                            editedCard?.subServiceCategoryId?._id,
                          ])
                        }
                        data={serviceCategories}
                        maxTagCount={"responsive"}
                      />
                    </Form.Item>
                    <Form.Item
                      name="price"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                        {
                          pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg "
                        }
                        placeholder="$ Original service price"
                        type="number"
                        controls={false}
                        defaultValue={isEditing ? editedCard?.servicePrice : ""}
                      />
                    </Form.Item>

                    <Form.Item
                      name="serviceName"
                      className="w-full rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4  "}
                        placeholder="Service Name"
                        value={editedCard?.serviceName}
                      />
                    </Form.Item>

                    <Form.Item
                      name="discountAmount"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                        {
                          pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                        {
                          validator: validateDiscount,
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg"
                        }
                        placeholder="$ Discount Amount"
                        type="number"
                        controls={false}
                        defaultValue={
                          isEditing ? editedCard?.discountAmount.toFixed(2) : ""
                        }
                      />
                    </Form.Item>

                    <Form.Item
                      name="variantTitle"
                      className="w-full rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4"}
                        placeholder="Variation Title"
                        value={editedCard?.serviceName}
                      />
                    </Form.Item>

                    <Form.Item name="video" className="w-full rounded-md ">
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4  "}
                        placeholder="Video Link"
                        value={editedCard?.video}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <p className="text-grey text-[12px]">
                      * You can select a default image for a service by clicking
                      on an image.
                    </p>
                  </div>
                  <Form.Item
                    name="multiple-images"
                    rules={[
                      {
                        required: isEditing ? false : true,
                        message: "Please upload at least 1 image!",
                      },
                    ]}
                    className="image-error-space"
                  >
                    <div
                      className="flex flex-col md:flex-row items-center rounded-md md:h-4"
                      name="multiple-images"
                    >
                      <label
                        htmlFor="multipleImageUpload"
                        className="flex flex-col cursor-pointer border-solid border-inputFieldGrey rounded-md group-hover:text-white justify-center h-6 !w-[246px] items-center bg-white hover:text-white text-primaryPurple border hover:bg-primaryPurple"
                      >
                        <PlusOutlined
                          className="justify-center"
                          style={{ fontSize: "18px" }}
                        />
                        Upload Multiple Images
                        <Input
                          type="file"
                          id="multipleImageUpload"
                          accept="image/*"
                          className="h-6 w-6"
                          style={{ display: "none" }}
                          onChange={handleChangeAndUploadMultipleImages}
                          multiple={true}
                        />
                      </label>
                      {files?.length || editedCard?.multipleImages?.length ? (
                        <div className="flex w-full overflow-x-auto scrollbar-hidden mt-2 md:mt-0">
                          {(files?.length
                            ? files
                            : editedCard?.multipleImages?.length > 0
                            ? editedCard?.multipleImages
                            : []
                          )?.map((item, i) => {
                            return (
                              <div className="ml-2 relative" key={i}>
                                <DeleteOutlined
                                  className="hover:cursor-pointer absolute top-[10px] right-0 bg-white cover-object"
                                  onClick={() => {
                                    handleMultipleDeleteUploadFileIcon(i);
                                  }}
                                />
                                <img
                                  onClick={() => {
                                    if (isEditing) {
                                      setSelectedFile({
                                        index: i,
                                        file: item?.file,
                                      });
                                    } else {
                                      setSelectedFile({
                                        index: i,
                                        file: item.file,
                                      });
                                    }
                                  }}
                                  src={item?.url || item?.file || item}
                                  alt="selected multiple image"
                                  className={`w-6 h-6 rounded-full object-contain ${
                                    selectedFile?.index === i
                                      ? "border-solid border-primaryPurple border-[4px]"
                                      : ""
                                  }`}
                                />
                              </div>
                            );
                          })}
                        </div>
                      ) : editedCard?.serviceImage ? (
                        <div className="flex w-full overflow-x-auto scrollbar-hidden mt-2 md:mt-0">
                          <div className="ml-2 relative">
                            <DeleteOutlined className="hover:cursor-pointer absolute top-[10px] right-0 bg-white cover-object" />
                            <img
                              src={editedCard?.serviceImage}
                              alt="selected multiple image"
                              className={`w-6 h-6 rounded-full object-contain border-solid border-primaryPurple border-2`}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </Form.Item>

                  {variants?.map((variant, index) => (
                    <div key={variant?.key} className="mb-4 ">
                      <h4>Variant {index + 2}</h4>
                      <div className="md:grid md:grid-cols-10 gap-2">
                        <Form.Item
                          className="w-full rounded-md md:col-span-2"
                          name={["variants", variant?.key, "variantTitle"]}
                          rules={[
                            {
                              required: true,
                              message: "Variant Title is required",
                            },
                          ]}
                        >
                          <InputField
                            placeholder="Variant Title"
                            defaultValue={
                              isEditing && editedCard?.variants[index]
                                ? editedCard?.variants[index]?.variantTitle
                                : ""
                            }
                            className="w-full hover:border-primaryBlue h-5.4"
                          />
                        </Form.Item>
                        <Form.Item
                          name={["variants", variant?.key, "servicePrice"]}
                          className="md:col-span-2"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                              message: "Please enter a positive number",
                            },
                          ]}
                        >
                          <InputNumber
                            className={
                              "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg "
                            }
                            placeholder="$ Service price"
                            type="number"
                            controls={false}
                            defaultValue={
                              isEditing && editedCard?.variants[index]
                                ? editedCard?.variants[index]?.servicePrice
                                : ""
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        </Form.Item>
                        <Form.Item
                          name={["variants", variant?.key, "discount"]}
                          className="md:col-span-2"
                          rules={[
                            {
                              required: true,
                              message: "This field is required",
                            },
                            {
                              pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                              message: "Please enter a positive number",
                            },
                            {
                              validator: async (_, value) => {
                                const formValues = form.getFieldsValue();
                                const currentVariant =
                                  formValues?.variants?.[index]; // Use variantIndex or key here
                                if (!currentVariant) {
                                  return Promise.reject(
                                    new Error("Variant not found")
                                  );
                                }

                                const servicePrice =
                                  currentVariant?.servicePrice;
                                if (value > servicePrice) {
                                  return Promise.reject(
                                    new Error(
                                      "Discount Amount cannot be greater than Service Price"
                                    )
                                  );
                                }

                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <InputNumber
                            className={
                              "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg"
                            }
                            placeholder="$ Discount Amount"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            controls={false}
                            defaultValue={
                              isEditing && editedCard?.variants[index]
                                ? editedCard?.variants[index]?.discountAmount
                                : ""
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          name={["variants", index, "serviceImage"]}
                          className="md:col-span-3 mt-1"
                        >
                          <div className="flex items-center rounded-md h-4">
                            <label
                              htmlFor={`imageUpload_${index}`}
                              className="flex flex-col cursor-pointer border-solid border-inputFieldGrey rounded-md group-hover:text-white justify-center h-6 w-24.6 items-center bg-white hover:text-white text-primaryPurple border hover:bg-primaryPurple"
                            >
                              <PlusOutlined
                                className="justify-center"
                                style={{ fontSize: "18px" }}
                              />
                              Upload Service Image
                              <Input
                                type="file"
                                id={`imageUpload_${index}`}
                                accept="image/*"
                                className="h-6 w-6"
                                style={{ display: "none" }}
                                onChange={(e) =>
                                  handleChangeAndUploadImageVariant(e, index)
                                }
                              />
                            </label>
                            <div className="ml-2">
                              {iloader[index] ? (
                                <div className="loader">
                                  <Spin indicator={<LoadingOutlined />} />
                                </div>
                              ) : null}
                            </div>
                            {(images[index] ||
                              editedCard?.variants?.[index]?.serviceImage) && (
                              <div className="ml-2 relative">
                                <DeleteOutlined
                                  className="hover:cursor-pointer absolute top-0 right-0 p-1 bg-white rounded-full"
                                  onClick={() =>
                                    handleDeleteUploadFileIconVariant(index)
                                  }
                                />
                                <img
                                  src={
                                    images[index] ||
                                    editedCard?.variants?.[index]?.serviceImage
                                  }
                                  alt="Selected Service Image"
                                  className="w-6 h-6 rounded-full"
                                />
                              </div>
                            )}
                          </div>
                        </Form.Item>
                        <div className="flex justify-end">
                          <DeleteIcon
                            className="hover:cursor-pointer"
                            onClick={() => handleRemoveVariant(variant)}
                          />
                        </div>
                      </div>
                      <Form.Item
                        className="w-full rounded-md md:col-span-2"
                        name={["variants", variant?.key, "serviceDescription"]}
                        rules={[
                          {
                            required: true,
                            message: "Variant Description is required",
                          },
                        ]}
                      >
                        {/* <TextArea
                          placeholder={"Variant Description"}
                          handleTextChange={(value) => {
                            handleTextOnChange(value);
                          }}
                          text={value.serviceDescription}
                          className="w-full rounded-xl hover:border-primaryBlue"
                          rows={3}
                        /> */}

                        <Input.TextArea
                          placeholder={"Variant Description"}
                          rows={3}
                          defaultValue={
                            isEditing && editedCard?.variants[index]
                              ? editedCard?.variants[index]?.serviceDescription
                              : ""
                          }
                        />
                      </Form.Item>
                      <div>
                        <h4 className="mt-4">What's included in the service</h4>
                        <div className="grid md:grid-cols-7 gap-2">
                          {serviceIncludesVariants[index]?.map(
                            (field, fieldIndex) => (
                              <React.Fragment
                                key={`includeService-${index}-${fieldIndex}`}
                              >
                                <Form.Item
                                  className="rounded-md col-span-3"
                                  name={[
                                    "variants",
                                    variant?.key,
                                    "includeService",
                                    fieldIndex,
                                  ]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                  ]}
                                >
                                  <InputField
                                    className="h-5.4"
                                    defaultValue={
                                      isEditing
                                        ? editedCard?.variants[index]
                                            ?.includeService[fieldIndex]
                                        : ""
                                    }
                                    onChange={(e) =>
                                      handleServiceIncludeChangeVariants(
                                        index,
                                        fieldIndex,
                                        e.target.value
                                      )
                                    }
                                  />
                                  {fieldIndex ===
                                    serviceIncludesVariants[index].length - 1 &&
                                    fieldIndex >= 2 && (
                                      <CloseCircleOutlined
                                        className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                        onClick={() =>
                                          handleRemoveLastFieldVariant(index)
                                        }
                                      />
                                    )}
                                </Form.Item>
                                {fieldIndex ===
                                  serviceIncludesVariants[index].length - 1 && (
                                  <Button
                                    className="bg-primaryPurple text-white px-4 rounded md:col-span-1 col-span-3"
                                    title={"Add"}
                                    onClick={() =>
                                      handleAddFieldsVariants(index)
                                    }
                                  >
                                    Add
                                  </Button>
                                )}
                              </React.Fragment>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="my-4">
                    <Button
                      color={colors.primaryPurple}
                      onClick={handleAddVariant}
                      icon={Addicon}
                      title="Add Another Variant"
                      htmlType={"button"}
                      className="w-full mt-2"
                    />
                  </div>
                  <div className="md:grid md:grid-cols-3 md:gap-2">
                    <div>
                      <p>Max Quantity (1-{businessMaxQuantity})</p>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                          },
                          {
                            pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                            message: "Please enter a positive number",
                          },
                          {
                            validator: validateQuantity,
                          },
                        ]}
                        name="quantity"
                        className="w-full rounded-md "
                      >
                        <InputNumber
                          className={
                            "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg"
                          }
                          placeholder="Max Quantity"
                          type="number"
                          controls={false}
                          defaultValue={
                            isEditing ? editedCard?.maxQuantity : ""
                          }
                        />
                        {/* <Dropdown
                          placeholder={"Yes"}
                          data={teslaService}
                          // disabled={true}
                          defaultValue={editedCard?.isAppointment}
                        /> */}
                      </Form.Item>
                    </div>
                    {showTesla ? (
                      <div>
                        <p className="sm:line-clamp-1">
                          Do You Service Tesla Vehicles with this Service
                        </p>

                        <Form.Item
                          name="isTeslaService"
                          className="w-full rounded-md"
                        >
                          <Dropdown
                            data={teslaService}
                            placeholder={"Yes"}
                            defaultValue={editedCard?.isTeslaService}
                          />
                        </Form.Item>
                      </div>
                    ) : (
                      <div>
                        <p className="sm:line-clamp-1">
                          Is this Kids Friendly?
                        </p>

                        <Form.Item
                          name="isKidsFriendly"
                          className="w-full rounded-md"
                        >
                          <Dropdown
                            data={teslaService}
                            placeholder={"Yes"}
                            defaultValue={editedCard?.isKidsFriendly}
                          />
                        </Form.Item>
                      </div>
                    )}
                    <div>
                      <p>Choose Appointment Type</p>
                      <Form.Item
                        name="promoDealType"
                        className="w-full rounded-md "
                      >
                        <Dropdown
                          data={promoDealCode}
                          placeholder={"Choose Appointment Type"}
                          defaultValue={editedCard?.promoDealType}
                        />
                      </Form.Item>
                    </div>
                  </div>

                  <div>
                    <p>Service Description</p>
                    <Form.Item name="serviceDescription">
                      <TextArea
                        placeholder={"Service Description"}
                        handleTextChange={(value) => {
                          handleTextOnChange(value);
                        }}
                        text={value.serviceDescription}
                        className="w-full rounded-xl hover:border-primaryBlue"
                        rows={3}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <p>What's Included In The Service?</p>
                    <div>
                      <Form.Item name="includeService">
                        <div className="w-full md:grid md:grid-cols-2 gap-2 ">
                          {isEditing ? (
                            <>
                              {editedCard?.includeService?.map((val, i) => (
                                <div key={i} className="relative">
                                  <Input
                                    onChange={(e) =>
                                      handleService(e.target.value, i, true)
                                    }
                                    className="w-full hover:border-primaryBlue h-5.4 pr-8 "
                                    defaultValue={val}
                                  />
                                  <CloseCircleOutlined
                                    onClick={() =>
                                      hadleRemoveservicewhileediting(i)
                                    }
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                  />
                                </div>
                              ))}
                            </>
                          ) : (
                            serviceObj?.map((inputs, i) => {
                              return (
                                <div key={i} className="relative">
                                  <InputField
                                    placeholder="."
                                    onChange={(e) => {
                                      handleService(e.target.value, i, false);
                                    }}
                                    className="w-full hover:border-primaryBlue h-5.4 pr-8 md:mb-0 mb-2"
                                  />

                                  {i >= 2 && (
                                    <CloseCircleOutlined
                                      onClick={() => handleRemoveService(i)}
                                      className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                    />
                                  )}
                                </div>
                              );
                            })
                          )}
                        </div>
                        <Button
                          color={colors.primaryPurple}
                          onClick={handleAddIncludedServices}
                          icon={Addicon}
                          title="Add"
                          htmlType={"button"}
                          className="w-full mt-2"
                        />
                      </Form.Item>
                    </div>

                    <div>
                      <p>Fine Print</p>
                      <TextArea
                        handleTextChange={(value, i) => {
                          handlefineprint(value);
                        }}
                        text={value.finePrint}
                        placeholder={"Fine Print"}
                        className="w-full rounded-xl hover:border-primaryBlue"
                        rows={3}
                      />
                    </div>
                  </div>
                  <div className="w-full flex justify-center lg:justify-end gap-2 mt-2 mb-4">
                    <Button
                      color={colors.primaryPurple}
                      title="Save"
                      htmlType={"submit"}
                      loading={loader}
                      className="w-19"
                    />
                  </div>
                </Form>
              </div>
            </div>

            {serviceCards?.items?.length ? (
              <>
                <div>
                  <p style={{ color: "#5530C1" }} className="font-normal	">
                    * Manage Your Appointment Time Offers From Your Messages Tab
                  </p>

                  <p className="text-lg font-medium tracking-wider">
                    Active Service Cards
                  </p>
                </div>
                <div>
                  <div className="mt-2">
                    {serviceCards?.items?.map((data, i) => {
                      return (
                        <div className="my-2 " key={i}>
                          <DealCard
                            openModal={() => showModal(data?._id)}
                            edit={() => {
                              scrollRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                              updateServiceCards(data);
                            }}
                            data={data}
                            isHomePage={true}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-center items-center pagination-container mb-2">
                    <Pagination
                      current={currentPage}
                      total={serviceCards?.totalItems}
                      pageSize={pageSize}
                      pageSizeOptions={[3, 10, 20, 30]}
                      // onShowSizeChange={handleSizeChange}
                      onChange={(e) => {
                        handlePageChange(e);
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            {isModalOpen && (
              <DeleteMemberModal
                title="Delete Service Card"
                text="Do you want to delete service card?"
                onCancel={hideModal}
                onOk={YesClickHandler}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
